import React, { useEffect, useState } from "react";
import List from "../meetingList";
import Filter from "../meetingFilter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import PATHS from "../../../../constants/paths";
import { BreadCrumb } from "@de-prado-dev/react-component-library";
import { useNavigate } from "react-router-dom";
import * as CourseService from "../../../../services/CourseService";
import * as FarmService from "../../../../services/visual/FarmService";
import { USER_PERMISSIONS } from "../../../security/permissions/rolesPermission";
import { Can } from "../../../security/permissions/Can";
import * as MeetingService from "../../../../services/MeetingService";
import moment from "moment";
import * as XLSX from "xlsx";

import {
  Header,
  HeaderTop,
  HeaderIcon,
  HeaderContent,
  Title,
  Subtitle,
  NewSessionButton,
  PageContainer,
  ExportButton,
} from "../../course/courseList/courseList.styled";

const queryClient = new QueryClient();

const MeetingFilterListContainer = (props) => {
  const { t } = useTranslation();
  const [filters, setFilters] = useState(undefined);
  const [coursesValues, setCoursesValues] = useState([]);
  const [farm, setFarm] = useState("");
  const navigate = useNavigate();
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.meeting.title") },
  ];

  const handlerCleanFilter = async (resetForm) => {
    resetForm();
    setFilters(undefined);
  };

  const goToForm = async () => {
    navigate(PATHS.CREATE_MEETING);
  };

  const exportToExcel = async () => {
    const filter = {
      filters: filters,
      sort: "date",
    };
    MeetingService.listToExport(filter).then((result) => {
      let fila;
      let numSessions;
      let employees;
      let speakers;
      // console.log("result", result);
      const data = result.data.map((item) => {
        numSessions = item.session?.length || 0;
        speakers = item.speakers?.length || 0;
        employees = item.center?.employees?.length || 0;
        fila = {
          A: item.course.name,
          B: item.center.name,
          C: item.month,
          D: item.year,
          E: numSessions,
          F: speakers,
          G: employees,
        };
        return fila;
      });

      const headers = {
        A: "Nombre Contenido",
        B: "Centro",
        C: "Mes",
        D: "Año",
        E: "Nº Sesiones planificadas",
        F: "Formadores",
        G: "Empleados",
      };

      data.unshift(headers);

      const filename = `Formaciones_${moment(new Date()).format(
        "DDMMYYYYHHmm"
      )}`;
      const sheetName = "Listado de Formaciones_";
      var ws = XLSX.utils.json_to_sheet(data, {
        header: ["A", "B", "C", "D", "E", "F", "G"],
        skipHeader: true,
        UTC: true,
        dateNF: "dd-mm-yyyy hh:mm;@",
      });

      // dateNF:'mm/dd/yyyy;@',cellDates:true, raw: true}
      const wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Listado de sesiones",
        Subject: "Exportación de sesiones",
        Author: "Assista",
        CreatedDate: new Date(),
      };
      wb.SheetNames.push(sheetName);
      wb.Sheets[sheetName] = ws;
      XLSX.writeFile(wb, filename + ".xlsx", {
        bookType: "xlsx",
        type: "binary",
      });
    });
  };

  const handlerOnSubmitFilter = (values) => {
    let newFilter = {};
    const valuesFilters = Object.entries(values);
    valuesFilters.forEach((value) => {
      if (value[1] !== undefined && value[1].toString().length > 0) {
        newFilter[value[0]] = value[1];
      }
    });

    setFilters(newFilter);
  };

  const handleChargeCourses = async () => {
    let courses = [];
    const result = await CourseService.listFilter({});
    for (let i = 0; i < result.docs.length; i++) {
      courses.push({ code: result.docs[i].uuid, label: result.docs[i].name });
    }
    setCoursesValues(courses);
  };

  const handlerFilterFinca = async (value) => {
    const filter = {
      filters: {
        name: value,
      },
    };
    const result = await FarmService.listFarms(filter.filters);
    return result;
  };

  const handleAddFarm = (inputFarm) => {
    setFarm(inputFarm.name);
  };

  useEffect(() => {
    handleChargeCourses();
  }, []);

  return (
    <>
      <PageContainer>
        <Header>
          <HeaderTop>
            <HeaderIcon>
              <i className="fas fa-people-group"></i>
            </HeaderIcon>
            <HeaderContent>
              <Title>{t("forms.meeting.title")}</Title>
              <Subtitle>{t("forms.meeting.subtitle")}</Subtitle>
            </HeaderContent>
            <Can do={USER_PERMISSIONS.CREATE_MEETING}>
              <NewSessionButton onClick={goToForm}>
                <i className="fas fa-plus"></i>
                {t("forms.meeting.buttons.new")}
              </NewSessionButton>
            </Can>
            <Can do={USER_PERMISSIONS.EXPORT}>
              <ExportButton onClick={exportToExcel}>
                <i className="fas fa-file-excel"></i>
                {t("forms.meeting.exportfileexcel")}
              </ExportButton>
            </Can>
          </HeaderTop>

          <Filter
            onSubmit={handlerOnSubmitFilter}
            onClean={handlerCleanFilter}
            coursesValues={coursesValues}
            onFilterFinca={handlerFilterFinca}
            onAddFarm={handleAddFarm}
          />
        </Header>
        <Header>
          <QueryClientProvider client={queryClient}>
            <List className="marg-top-1rem" filters={filters} />
          </QueryClientProvider>
        </Header>
      </PageContainer>
      {/* <div className="row justify-content-center mt-5">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">{t("forms.meeting.title")}</h3>
        </div>
      </div>
      <BreadCrumb items={breads} />
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <Filter
            onSubmit={handlerOnSubmitFilter}
            onClean={handlerCleanFilter}
            coursesValues={coursesValues}
            onFilterFinca={handlerFilterFinca}
            onAddFarm={handleAddFarm}
          />
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <QueryClientProvider client={queryClient}>
            <List className="marg-top-1rem" filters={filters} />
          </QueryClientProvider>
        </div>
      </div>
      <div className="row justify-content-center mt-4 mb-5">
        <div className="col-12 col-md-11 d-flex justify-content-center">
          <Can do={USER_PERMISSIONS.CREATE_MEETING}>
            <button
              className="btn btn-secondary btn-md"
              onClick={() => goToForm()}
            >
              {t("forms.meeting.buttons.new")}
            </button>
          </Can>
        </div>
      </div> */}
    </>
  );
};

MeetingFilterListContainer.propTypes = {};

export default MeetingFilterListContainer;
